/* eslint-disable consistent-return */
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import msalInstance from "./msalInstance";
import { loginRequest } from "./authConfig";

export const acquireToken = async () => {
  if (!msalInstance.initialized) {
    await msalInstance.initialize();
  }

  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw new Error("No active account! User must be logged in.");
  }

  const request = {
    ...loginRequest,
    account,
  };

  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      msalInstance.acquireTokenRedirect(request);
    } else {
      throw error;
    }
  }
};
